import {
  type AvailableQuarry,
  type UserQuarry,
} from '@common/types/quarryType';

const addLocalStockUpdatedAtField =
  <T extends UserQuarry | AvailableQuarry>(now: number) =>
  (quarry: T): T => ({
    ...quarry,
    localStockUpdatedAt: new Date(now).toISOString(),
  });

export { addLocalStockUpdatedAtField };
